/* tslint:disable */
/* eslint-disable */
/**
 * SPD
 * Opis api SPD
 *
 * The version of the OpenAPI document: 1.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
import type { GetSalesInvoiceDto } from './GetSalesInvoiceDto';
import {
    GetSalesInvoiceDtoFromJSON,
    GetSalesInvoiceDtoFromJSONTyped,
    GetSalesInvoiceDtoToJSON,
} from './GetSalesInvoiceDto';

/**
 * 
 * @export
 * @interface GetSalesInvoicePositionDto
 */
export interface GetSalesInvoicePositionDto {
    /**
     * 
     * @type {string}
     * @memberof GetSalesInvoicePositionDto
     */
    id: string;
    /**
     * 
     * @type {string}
     * @memberof GetSalesInvoicePositionDto
     */
    name: string;
    /**
     * 
     * @type {string}
     * @memberof GetSalesInvoicePositionDto
     */
    amount: string;
    /**
     * 
     * @type {number}
     * @memberof GetSalesInvoicePositionDto
     */
    order: number;
    /**
     * 
     * @type {number}
     * @memberof GetSalesInvoicePositionDto
     */
    quantity?: number;
    /**
     * 
     * @type {GetSalesInvoiceDto}
     * @memberof GetSalesInvoicePositionDto
     */
    salesInvoice: GetSalesInvoiceDto;
    /**
     * 
     * @type {string}
     * @memberof GetSalesInvoicePositionDto
     */
    vat: GetSalesInvoicePositionDtoVatEnum;
    /**
     * 
     * @type {boolean}
     * @memberof GetSalesInvoicePositionDto
     */
    active: boolean;
    /**
     * 
     * @type {boolean}
     * @memberof GetSalesInvoicePositionDto
     */
    isLocked?: boolean;
    /**
     * 
     * @type {string}
     * @memberof GetSalesInvoicePositionDto
     */
    parentId?: string | null;
}


/**
 * @export
 */
export const GetSalesInvoicePositionDtoVatEnum = {
    _23: '23%',
    _8: '8%',
    _5: '5%',
    _0_KR: '0% KR',
    zw: 'zw.'
} as const;
export type GetSalesInvoicePositionDtoVatEnum = typeof GetSalesInvoicePositionDtoVatEnum[keyof typeof GetSalesInvoicePositionDtoVatEnum];


/**
 * Check if a given object implements the GetSalesInvoicePositionDto interface.
 */
export function instanceOfGetSalesInvoicePositionDto(value: object): value is GetSalesInvoicePositionDto {
    if (!('id' in value) || value['id'] === undefined) return false;
    if (!('name' in value) || value['name'] === undefined) return false;
    if (!('amount' in value) || value['amount'] === undefined) return false;
    if (!('order' in value) || value['order'] === undefined) return false;
    if (!('salesInvoice' in value) || value['salesInvoice'] === undefined) return false;
    if (!('vat' in value) || value['vat'] === undefined) return false;
    if (!('active' in value) || value['active'] === undefined) return false;
    return true;
}

export function GetSalesInvoicePositionDtoFromJSON(json: any): GetSalesInvoicePositionDto {
    return GetSalesInvoicePositionDtoFromJSONTyped(json, false);
}

export function GetSalesInvoicePositionDtoFromJSONTyped(json: any, ignoreDiscriminator: boolean): GetSalesInvoicePositionDto {
    if (json == null) {
        return json;
    }
    return {
        
        'id': json['id'],
        'name': json['name'],
        'amount': json['amount'],
        'order': json['order'],
        'quantity': json['quantity'] == null ? undefined : json['quantity'],
        'salesInvoice': GetSalesInvoiceDtoFromJSON(json['salesInvoice']),
        'vat': json['vat'],
        'active': json['active'],
        'isLocked': json['isLocked'] == null ? undefined : json['isLocked'],
        'parentId': json['parentId'] == null ? undefined : json['parentId'],
    };
}

export function GetSalesInvoicePositionDtoToJSON(value?: GetSalesInvoicePositionDto | null): any {
    if (value == null) {
        return value;
    }
    return {
        
        'id': value['id'],
        'name': value['name'],
        'amount': value['amount'],
        'order': value['order'],
        'quantity': value['quantity'],
        'salesInvoice': GetSalesInvoiceDtoToJSON(value['salesInvoice']),
        'vat': value['vat'],
        'active': value['active'],
        'isLocked': value['isLocked'],
        'parentId': value['parentId'],
    };
}

